import {
	defineMessages
} from 'react-intl';

export default defineMessages({
	freshMint: {
		'id': 'landing.freshMint',
		'defaultMessage': 'FreshMint',
	},
	platform: {
		'id': 'landing.platform',
		'defaultMessage': 'Platform',
	},
	howItWorks: {
		'id': 'landing.howItWorks',
		'defaultMessage': 'How To Stog',
	},
	features: {
		'id': 'landing.features',
		'defaultMessage': 'Features',
	},
	techSpecs: {
		'id': 'landing.techSpecs',
		'defaultMessage': 'Tech Specs',
	},
	saleAndRent: {
		'id': 'landing.saleAndRent',
		'defaultMessage': 'Sale and Rent',
	}
});


// WEBPACK FOOTER //
// ./src/components/Landing/messages.js